// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonDropDown{
    position: relative;
    width: 150px;
    height: 39px;
}

.commonDropDown_wrap{
    z-index:1;
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 0px;
    background: #F3F6FF;
    border-radius: 17px;
    width: 100%;
}

.commonDropDown--opened{
}

.commonDropDown_header{
    display: flex;
    justify-content: space-between;
    align-items: center;

    border: none;
    width: 100%;
    height: 39px;
    background: #F3F6FF;
    border-radius: 30px;

    font-weight: 400;
    font-size: calc(10px * var(--fontScaler));
    line-height: 150%;
    color: #B8BCCA;
    padding: 0px 20px;
}

.commonDropDown_value{

}

.commonDropDown_arrow{
    width: 15px;
    height: 15px;
    border-radius: 100%;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 8px;
    background-position: center;
    background-repeat: no-repeat;
}

.commonDropDown_list_wrap{
    display: grid;
    grid-template-rows: 0fr;
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;

    border: none;
    width: 100%;

    font-weight: 400;
    font-size: calc(10px * var(--fontScaler));
    line-height: 150%;
    color: #B8BCCA;
}

.commonDropDown--opened .commonDropDown_list_wrap{
    grid-template-rows: 1fr;
}

.commonDropDown_list{
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.commonDropDown_list--scroll{
    overflow-y: auto;
}

.commonDropDown_list--scroll::-webkit-scrollbar-track{
    background: #fff0;
}

.commonDropDown_item{
    padding: 4px 20px;
}

.commonDropDown_item:hover{
    padding: 4px 20px;
    background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/dropDown/DropDown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;;IAEnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;;IAEd,yDAAoD;IACpD,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,+DAA+D;IAC/D,gBAAgB;;IAEhB,YAAY;IACZ,WAAW;;IAEX,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B","sourcesContent":[".commonDropDown{\n    position: relative;\n    width: 150px;\n    height: 39px;\n}\n\n.commonDropDown_wrap{\n    z-index:1;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n    background: #F3F6FF;\n    border-radius: 17px;\n    width: 100%;\n}\n\n.commonDropDown--opened{\n}\n\n.commonDropDown_header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    border: none;\n    width: 100%;\n    height: 39px;\n    background: #F3F6FF;\n    border-radius: 30px;\n\n    font-weight: 400;\n    font-size: calc(10px * var(--fontScaler));\n    line-height: 150%;\n    color: #B8BCCA;\n    padding: 0px 20px;\n}\n\n.commonDropDown_value{\n\n}\n\n.commonDropDown_arrow{\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    flex-shrink: 0;\n\n    background-image: url('../../assets/open-arrow.svg');\n    background-size: 8px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.commonDropDown_list_wrap{\n    display: grid;\n    grid-template-rows: 0fr;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n\n    border: none;\n    width: 100%;\n\n    font-weight: 400;\n    font-size: calc(10px * var(--fontScaler));\n    line-height: 150%;\n    color: #B8BCCA;\n}\n\n.commonDropDown--opened .commonDropDown_list_wrap{\n    grid-template-rows: 1fr;\n}\n\n.commonDropDown_list{\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n}\n\n.commonDropDown_list--scroll{\n    overflow-y: auto;\n}\n\n.commonDropDown_list--scroll::-webkit-scrollbar-track{\n    background: #fff0;\n}\n\n.commonDropDown_item{\n    padding: 4px 20px;\n}\n\n.commonDropDown_item:hover{\n    padding: 4px 20px;\n    background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
